import * as i0 from '@angular/core';
import { inject, Injectable, NgModule, InjectionToken } from '@angular/core';
import * as i2 from '@spartacus/core';
import { UserIdService, CommandService, CommandStrategy, OCC_USER_ID_ANONYMOUS, PageMetaResolver, PageType } from '@spartacus/core';
import * as i4 from '@spartacus/checkout/base/root';
import { CheckoutQueryFacade, CheckoutDeliveryAddressCreatedEvent, CheckoutDeliveryAddressSetEvent, CheckoutDeliveryAddressClearedEvent, CheckoutSupportedDeliveryModesQueryReloadEvent, CheckoutSupportedDeliveryModesQueryResetEvent, CheckoutDeliveryModeSetEvent, CheckoutDeliveryModeClearedEvent, CheckoutDeliveryModeClearedErrorEvent, CheckoutPaymentCardTypesQueryReloadEvent, CheckoutPaymentCardTypesQueryResetEvent, CheckoutPaymentDetailsCreatedEvent, CheckoutPaymentDetailsSetEvent, CheckoutQueryReloadEvent, CheckoutQueryResetEvent, CheckoutDeliveryAddressFacade, CheckoutDeliveryModesFacade, CheckoutPaymentFacade, CheckoutBillingAddressFacade } from '@spartacus/checkout/base/root';
import * as i1 from '@spartacus/cart/base/root';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { combineLatest } from 'rxjs';
import { switchMap, take, map, tap, filter } from 'rxjs/operators';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CheckoutBillingAddressAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutBillingAddressConnector = /*#__PURE__*/(() => {
  class CheckoutBillingAddressConnector {
    constructor() {
      this.adapter = inject(CheckoutBillingAddressAdapter);
    }
    setBillingAddress(userId, cartId, address) {
      return this.adapter.setBillingAddress(userId, cartId, address);
    }
    static {
      this.ɵfac = function CheckoutBillingAddressConnector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutBillingAddressConnector)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutBillingAddressConnector,
        factory: CheckoutBillingAddressConnector.ɵfac
      });
    }
  }
  return CheckoutBillingAddressConnector;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CheckoutDeliveryAddressAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutDeliveryAddressConnector = /*#__PURE__*/(() => {
  class CheckoutDeliveryAddressConnector {
    constructor(adapter) {
      this.adapter = adapter;
    }
    createAddress(userId, cartId, address) {
      return this.adapter.createAddress(userId, cartId, address);
    }
    setAddress(userId, cartId, addressId) {
      return this.adapter.setAddress(userId, cartId, addressId);
    }
    clearCheckoutDeliveryAddress(userId, cartId) {
      return this.adapter.clearCheckoutDeliveryAddress(userId, cartId);
    }
    static {
      this.ɵfac = function CheckoutDeliveryAddressConnector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutDeliveryAddressConnector)(i0.ɵɵinject(CheckoutDeliveryAddressAdapter));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutDeliveryAddressConnector,
        factory: CheckoutDeliveryAddressConnector.ɵfac
      });
    }
  }
  return CheckoutDeliveryAddressConnector;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CheckoutDeliveryModesAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutDeliveryModesConnector = /*#__PURE__*/(() => {
  class CheckoutDeliveryModesConnector {
    constructor(adapter) {
      this.adapter = adapter;
    }
    setMode(userId, cartId, deliveryModeId) {
      return this.adapter.setMode(userId, cartId, deliveryModeId);
    }
    getSupportedModes(userId, cartId) {
      return this.adapter.getSupportedModes(userId, cartId);
    }
    clearCheckoutDeliveryMode(userId, cartId) {
      return this.adapter.clearCheckoutDeliveryMode(userId, cartId);
    }
    static {
      this.ɵfac = function CheckoutDeliveryModesConnector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutDeliveryModesConnector)(i0.ɵɵinject(CheckoutDeliveryModesAdapter));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutDeliveryModesConnector,
        factory: CheckoutDeliveryModesConnector.ɵfac
      });
    }
  }
  return CheckoutDeliveryModesConnector;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CheckoutPaymentAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPaymentConnector = /*#__PURE__*/(() => {
  class CheckoutPaymentConnector {
    constructor(adapter) {
      this.adapter = adapter;
    }
    createPaymentDetails(userId, cartId, paymentDetails) {
      return this.adapter.createPaymentDetails(userId, cartId, paymentDetails);
    }
    setPaymentDetails(userId, cartId, paymentDetailsId) {
      return this.adapter.setPaymentDetails(userId, cartId, paymentDetailsId);
    }
    getPaymentCardTypes() {
      return this.adapter.getPaymentCardTypes();
    }
    static {
      this.ɵfac = function CheckoutPaymentConnector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPaymentConnector)(i0.ɵɵinject(CheckoutPaymentAdapter));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutPaymentConnector,
        factory: CheckoutPaymentConnector.ɵfac
      });
    }
  }
  return CheckoutPaymentConnector;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CheckoutAdapter {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutConnector = /*#__PURE__*/(() => {
  class CheckoutConnector {
    constructor(adapter) {
      this.adapter = adapter;
    }
    getCheckoutDetails(userId, cartId) {
      return this.adapter.getCheckoutDetails(userId, cartId);
    }
    static {
      this.ɵfac = function CheckoutConnector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutConnector)(i0.ɵɵinject(CheckoutAdapter));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutConnector,
        factory: CheckoutConnector.ɵfac
      });
    }
  }
  return CheckoutConnector;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutBillingAddressService = /*#__PURE__*/(() => {
  class CheckoutBillingAddressService {
    constructor() {
      this.activeCartFacade = inject(ActiveCartFacade);
      this.userIdService = inject(UserIdService);
      this.commandService = inject(CommandService);
      this.checkoutBillingAddressConnector = inject(CheckoutBillingAddressConnector);
      this.checkoutQueryFacade = inject(CheckoutQueryFacade);
      this.setBillingAddressCommand = this.commandService.create(address => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => {
        if (!address || !Object.keys(address)?.length) {
          throw new Error('Checkout conditions not met');
        }
        return this.checkoutBillingAddressConnector.setBillingAddress(userId, cartId, address);
      })), {
        strategy: CommandStrategy.CancelPrevious
      });
    }
    /**
     * Performs the necessary checkout preconditions.
     */
    checkoutPreconditions() {
      return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.takeActiveCartId(), this.activeCartFacade.isGuestCart()]).pipe(take(1), map(([userId, cartId, isGuestCart]) => {
        if (!userId || !cartId || userId === OCC_USER_ID_ANONYMOUS && !isGuestCart) {
          throw new Error('Checkout conditions not met');
        }
        return [userId, cartId];
      }));
    }
    setBillingAddress(address) {
      return this.setBillingAddressCommand.execute(address);
    }
    static {
      this.ɵfac = function CheckoutBillingAddressService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutBillingAddressService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutBillingAddressService,
        factory: CheckoutBillingAddressService.ɵfac
      });
    }
  }
  return CheckoutBillingAddressService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutDeliveryAddressService = /*#__PURE__*/(() => {
  class CheckoutDeliveryAddressService {
    constructor(activeCartFacade, userIdService, eventService, commandService, checkoutDeliveryAddressConnector, checkoutQueryFacade) {
      this.activeCartFacade = activeCartFacade;
      this.userIdService = userIdService;
      this.eventService = eventService;
      this.commandService = commandService;
      this.checkoutDeliveryAddressConnector = checkoutDeliveryAddressConnector;
      this.checkoutQueryFacade = checkoutQueryFacade;
      this.createDeliveryAddressCommand = this.commandService.create(payload => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => {
        return this.checkoutDeliveryAddressConnector.createAddress(userId, cartId, payload).pipe(map(address => {
          address.titleCode = payload.titleCode;
          if (payload.region?.isocodeShort) {
            address.region = {
              ...address.region,
              isocodeShort: payload.region.isocodeShort
            };
          }
          return address;
        }), tap(address => this.eventService.dispatch({
          userId,
          cartId,
          address
        }, CheckoutDeliveryAddressCreatedEvent)));
      })), {
        strategy: CommandStrategy.CancelPrevious
      });
      this.setDeliveryAddressCommand = this.commandService.create(address => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => {
        const addressId = address.id;
        if (!addressId) {
          throw new Error('Checkout conditions not met');
        }
        return this.checkoutDeliveryAddressConnector.setAddress(userId, cartId, addressId).pipe(tap(() => {
          this.eventService.dispatch({
            userId,
            cartId,
            address
          }, CheckoutDeliveryAddressSetEvent);
        }));
      })), {
        strategy: CommandStrategy.CancelPrevious
      });
      this.clearDeliveryAddressCommand = this.commandService.create(() => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.checkoutDeliveryAddressConnector.clearCheckoutDeliveryAddress(userId, cartId).pipe(tap(() => {
        this.eventService.dispatch({
          userId,
          cartId
        }, CheckoutDeliveryAddressClearedEvent);
      })))), {
        strategy: CommandStrategy.CancelPrevious
      });
    }
    /**
     * Performs the necessary checkout preconditions.
     */
    checkoutPreconditions() {
      return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.takeActiveCartId(), this.activeCartFacade.isGuestCart()]).pipe(take(1), map(([userId, cartId, isGuestCart]) => {
        if (!userId || !cartId || userId === OCC_USER_ID_ANONYMOUS && !isGuestCart) {
          throw new Error('Checkout conditions not met');
        }
        return [userId, cartId];
      }));
    }
    getDeliveryAddressState() {
      return this.checkoutQueryFacade.getCheckoutDetailsState().pipe(map(state => ({
        ...state,
        data: state.data?.deliveryAddress
      })));
    }
    createAndSetAddress(address) {
      return this.createDeliveryAddressCommand.execute(address);
    }
    setDeliveryAddress(address) {
      return this.setDeliveryAddressCommand.execute(address);
    }
    clearCheckoutDeliveryAddress() {
      return this.clearDeliveryAddressCommand.execute();
    }
    static {
      this.ɵfac = function CheckoutDeliveryAddressService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutDeliveryAddressService)(i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i2.EventService), i0.ɵɵinject(i2.CommandService), i0.ɵɵinject(CheckoutDeliveryAddressConnector), i0.ɵɵinject(i4.CheckoutQueryFacade));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutDeliveryAddressService,
        factory: CheckoutDeliveryAddressService.ɵfac
      });
    }
  }
  return CheckoutDeliveryAddressService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutDeliveryModesService = /*#__PURE__*/(() => {
  class CheckoutDeliveryModesService {
    /**
     * Returns the reload events for the supportedDeliveryModes query
     */
    getCheckoutSupportedDeliveryModesQueryReloadEvents() {
      return [CheckoutSupportedDeliveryModesQueryReloadEvent];
    }
    /**
     * Return the reset events for the supportedDeliveryModes query
     */
    getCheckoutSupportedDeliveryModesQueryResetEvents() {
      return [CheckoutSupportedDeliveryModesQueryResetEvent];
    }
    constructor(activeCartFacade, userIdService, eventService, queryService, commandService, checkoutDeliveryModesConnector, checkoutQueryFacade) {
      this.activeCartFacade = activeCartFacade;
      this.userIdService = userIdService;
      this.eventService = eventService;
      this.queryService = queryService;
      this.commandService = commandService;
      this.checkoutDeliveryModesConnector = checkoutDeliveryModesConnector;
      this.checkoutQueryFacade = checkoutQueryFacade;
      this.supportedDeliveryModesQuery = this.queryService.create(() => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.checkoutDeliveryModesConnector.getSupportedModes(userId, cartId))), {
        reloadOn: this.getCheckoutSupportedDeliveryModesQueryReloadEvents(),
        resetOn: this.getCheckoutSupportedDeliveryModesQueryResetEvents()
      });
      this.setDeliveryModeCommand = this.commandService.create(deliveryModeCode => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.checkoutDeliveryModesConnector.setMode(userId, cartId, deliveryModeCode).pipe(tap(() => {
        this.eventService.dispatch({
          userId,
          cartId,
          cartCode: cartId,
          deliveryModeCode
        }, CheckoutDeliveryModeSetEvent);
      })))), {
        strategy: CommandStrategy.CancelPrevious
      });
      this.clearDeliveryModeCommand = this.commandService.create(() => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.checkoutDeliveryModesConnector.clearCheckoutDeliveryMode(userId, cartId).pipe(tap({
        next: () => {
          this.eventService.dispatch({
            userId,
            cartId,
            /**
             * As we know the cart is not anonymous (precondition checked),
             * we can safely use the cartId, which is actually the cart.code.
             */
            cartCode: cartId
          }, CheckoutDeliveryModeClearedEvent);
        },
        error: () => {
          this.eventService.dispatch({
            userId,
            cartId,
            /**
             * As we know the cart is not anonymous (precondition checked),
             * we can safely use the cartId, which is actually the cart.code.
             */
            cartCode: cartId
          }, CheckoutDeliveryModeClearedErrorEvent);
        }
      })))), {
        strategy: CommandStrategy.CancelPrevious
      });
    }
    /**
     * Performs the necessary checkout preconditions.
     */
    checkoutPreconditions() {
      return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.takeActiveCartId(), this.activeCartFacade.isGuestCart()]).pipe(take(1), map(([userId, cartId, isGuestCart]) => {
        if (!userId || !cartId || userId === OCC_USER_ID_ANONYMOUS && !isGuestCart) {
          throw new Error('Checkout conditions not met');
        }
        return [userId, cartId];
      }));
    }
    getSupportedDeliveryModesState() {
      return this.supportedDeliveryModesQuery.getState();
    }
    getSupportedDeliveryModes() {
      return this.getSupportedDeliveryModesState().pipe(filter(state => !state.loading), map(state => state.data ?? []));
    }
    getSelectedDeliveryModeState() {
      return this.checkoutQueryFacade.getCheckoutDetailsState().pipe(map(state => ({
        ...state,
        data: state.data?.deliveryMode
      })));
    }
    setDeliveryMode(mode) {
      return this.setDeliveryModeCommand.execute(mode);
    }
    clearCheckoutDeliveryMode() {
      return this.clearDeliveryModeCommand.execute();
    }
    static {
      this.ɵfac = function CheckoutDeliveryModesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutDeliveryModesService)(i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i2.EventService), i0.ɵɵinject(i2.QueryService), i0.ɵɵinject(i2.CommandService), i0.ɵɵinject(CheckoutDeliveryModesConnector), i0.ɵɵinject(i4.CheckoutQueryFacade));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutDeliveryModesService,
        factory: CheckoutDeliveryModesService.ɵfac
      });
    }
  }
  return CheckoutDeliveryModesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPaymentService = /*#__PURE__*/(() => {
  class CheckoutPaymentService {
    /**
     * Returns the reload events for the cardTypes query
     */
    getCheckoutPaymentCardTypesQueryReloadEvents() {
      return [CheckoutPaymentCardTypesQueryReloadEvent];
    }
    /**
     * Returns the reset events for the cardTypes query
     */
    getCheckoutPaymentCardTypesQueryResetEvents() {
      return [CheckoutPaymentCardTypesQueryResetEvent];
    }
    constructor(activeCartFacade, userIdService, queryService, commandService, eventService, checkoutPaymentConnector, checkoutQueryFacade) {
      this.activeCartFacade = activeCartFacade;
      this.userIdService = userIdService;
      this.queryService = queryService;
      this.commandService = commandService;
      this.eventService = eventService;
      this.checkoutPaymentConnector = checkoutPaymentConnector;
      this.checkoutQueryFacade = checkoutQueryFacade;
      this.paymentCardTypesQuery = this.queryService.create(() => this.checkoutPaymentConnector.getPaymentCardTypes(), {
        reloadOn: this.getCheckoutPaymentCardTypesQueryReloadEvents(),
        resetOn: this.getCheckoutPaymentCardTypesQueryResetEvents()
      });
      this.createPaymentMethodCommand = this.commandService.create(paymentDetails => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.checkoutPaymentConnector.createPaymentDetails(userId, cartId, paymentDetails).pipe(tap(response => this.eventService.dispatch({
        userId,
        cartId,
        paymentDetails: response
      }, CheckoutPaymentDetailsCreatedEvent))))), {
        strategy: CommandStrategy.CancelPrevious
      });
      this.setPaymentMethodCommand = this.commandService.create(paymentDetails => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => {
        const paymentDetailsId = paymentDetails?.id;
        if (!paymentDetailsId) {
          throw new Error('Checkout conditions not met');
        }
        return this.checkoutPaymentConnector.setPaymentDetails(userId, cartId, paymentDetailsId).pipe(tap(() => this.eventService.dispatch({
          userId,
          cartId,
          paymentDetailsId
        }, CheckoutPaymentDetailsSetEvent)));
      })), {
        strategy: CommandStrategy.CancelPrevious
      });
    }
    /**
     * Performs the necessary checkout preconditions.
     */
    checkoutPreconditions() {
      return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.takeActiveCartId(), this.activeCartFacade.isGuestCart()]).pipe(take(1), map(([userId, cartId, isGuestCart]) => {
        if (!userId || !cartId || userId === OCC_USER_ID_ANONYMOUS && !isGuestCart) {
          throw new Error('Checkout conditions not met');
        }
        return [userId, cartId];
      }));
    }
    getPaymentCardTypesState() {
      return this.paymentCardTypesQuery.getState();
    }
    getPaymentCardTypes() {
      return this.getPaymentCardTypesState().pipe(map(state => state.data ?? []));
    }
    getPaymentDetailsState() {
      return this.checkoutQueryFacade.getCheckoutDetailsState().pipe(map(state => ({
        ...state,
        data: state.data?.paymentInfo
      })));
    }
    createPaymentDetails(paymentDetails) {
      return this.createPaymentMethodCommand.execute(paymentDetails);
    }
    setPaymentDetails(paymentDetails) {
      return this.setPaymentMethodCommand.execute(paymentDetails);
    }
    static {
      this.ɵfac = function CheckoutPaymentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPaymentService)(i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i2.QueryService), i0.ɵɵinject(i2.CommandService), i0.ɵɵinject(i2.EventService), i0.ɵɵinject(CheckoutPaymentConnector), i0.ɵɵinject(i4.CheckoutQueryFacade));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutPaymentService,
        factory: CheckoutPaymentService.ɵfac
      });
    }
  }
  return CheckoutPaymentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutQueryService = /*#__PURE__*/(() => {
  class CheckoutQueryService {
    /**
     * Returns the reload events for the checkout query.
     */
    getCheckoutQueryReloadEvents() {
      return [CheckoutQueryReloadEvent];
    }
    /**
     * Returns the reset events for the checkout query.
     */
    getCheckoutQueryResetEvents() {
      return [CheckoutQueryResetEvent];
    }
    constructor(activeCartFacade, userIdService, queryService, checkoutConnector) {
      this.activeCartFacade = activeCartFacade;
      this.userIdService = userIdService;
      this.queryService = queryService;
      this.checkoutConnector = checkoutConnector;
      this.checkoutQuery$ = this.queryService.create(() => this.checkoutPreconditions().pipe(switchMap(([userId, cartId]) => this.checkoutConnector.getCheckoutDetails(userId, cartId))), {
        reloadOn: this.getCheckoutQueryReloadEvents(),
        resetOn: this.getCheckoutQueryResetEvents()
      });
    }
    /**
     * Performs the necessary checkout preconditions.
     */
    checkoutPreconditions() {
      return combineLatest([this.userIdService.takeUserId(), this.activeCartFacade.takeActiveCartId(), this.activeCartFacade.isGuestCart()]).pipe(take(1), map(([userId, cartId, isGuestCart]) => {
        if (!userId || !cartId || userId === OCC_USER_ID_ANONYMOUS && !isGuestCart) {
          throw new Error('Checkout conditions not met');
        }
        return [userId, cartId];
      }));
    }
    getCheckoutDetailsState() {
      return this.checkoutQuery$.getState();
    }
    static {
      this.ɵfac = function CheckoutQueryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutQueryService)(i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i2.UserIdService), i0.ɵɵinject(i2.QueryService), i0.ɵɵinject(CheckoutConnector));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutQueryService,
        factory: CheckoutQueryService.ɵfac
      });
    }
  }
  return CheckoutQueryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const facadeProviders = [CheckoutDeliveryAddressService, {
  provide: CheckoutDeliveryAddressFacade,
  useExisting: CheckoutDeliveryAddressService
}, CheckoutDeliveryModesService, {
  provide: CheckoutDeliveryModesFacade,
  useExisting: CheckoutDeliveryModesService
}, CheckoutPaymentService, {
  provide: CheckoutPaymentFacade,
  useExisting: CheckoutPaymentService
}, CheckoutQueryService, {
  provide: CheckoutQueryFacade,
  useExisting: CheckoutQueryService
}, CheckoutBillingAddressService, {
  provide: CheckoutBillingAddressFacade,
  useExisting: CheckoutBillingAddressService
}];

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Resolves the page data for all Content Pages based on the `PageType.CONTENT_PAGE`
 * and the `MultiStepCheckoutSummaryPageTemplate`. If the checkout page matches this template,
 * the more generic `ContentPageMetaResolver` is overridden by this resolver.
 *
 * The page title and robots are resolved in this implementation only.
 */
let CheckoutPageMetaResolver = /*#__PURE__*/(() => {
  class CheckoutPageMetaResolver extends PageMetaResolver {
    constructor(translationService, activeCartFacade, basePageMetaResolver) {
      super();
      this.translationService = translationService;
      this.activeCartFacade = activeCartFacade;
      this.basePageMetaResolver = basePageMetaResolver;
      this.pageType = PageType.CONTENT_PAGE;
      this.pageTemplate = 'MultiStepCheckoutSummaryPageTemplate';
    }
    /**
     * @override
     * Resolves the page title for the Checkout Page to include checkout step.
     * The page title used by the browser (history, tabs) and crawlers.
     *
     * The title from the page data is ignored for this page title.
     */
    resolveTitle() {
      return this.basePageMetaResolver.resolveTitle();
    }
    /**
     * Resolves the page heading for the Checkout Page.
     * The page heading is used in the UI (`<h1>`), where as the page
     * title is used by the browser and crawlers.
     */
    resolveHeading() {
      return this.translationService.translate('pageMetaResolver.checkout.title');
    }
    resolveDescription() {
      return this.basePageMetaResolver.resolveDescription();
    }
    resolveRobots() {
      return this.basePageMetaResolver.resolveRobots();
    }
    static {
      this.ɵfac = function CheckoutPageMetaResolver_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPageMetaResolver)(i0.ɵɵinject(i2.TranslationService), i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i2.BasePageMetaResolver));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutPageMetaResolver,
        factory: CheckoutPageMetaResolver.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutPageMetaResolver;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutCoreModule = /*#__PURE__*/(() => {
  class CheckoutCoreModule {
    static {
      this.ɵfac = function CheckoutCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutCoreModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutCoreModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [...facadeProviders, CheckoutDeliveryAddressConnector, CheckoutBillingAddressConnector, CheckoutDeliveryModesConnector, CheckoutPaymentConnector, CheckoutConnector, CheckoutPageMetaResolver, {
          provide: PageMetaResolver,
          useExisting: CheckoutPageMetaResolver,
          multi: true
        }]
      });
    }
  }
  return CheckoutCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const DELIVERY_MODE_NORMALIZER = new InjectionToken('DeliveryModeNormalizer');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const PAYMENT_DETAILS_SERIALIZER = new InjectionToken('PaymentDetailsSerializer');
const PAYMENT_CARD_TYPE_NORMALIZER = new InjectionToken('PaymentCardTypeNormalizer');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CHECKOUT_NORMALIZER = new InjectionToken('CheckoutNormalizer');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CHECKOUT_NORMALIZER, CheckoutAdapter, CheckoutBillingAddressAdapter, CheckoutBillingAddressService, CheckoutConnector, CheckoutCoreModule, CheckoutDeliveryAddressAdapter, CheckoutDeliveryAddressConnector, CheckoutDeliveryAddressService, CheckoutDeliveryModesAdapter, CheckoutDeliveryModesConnector, CheckoutDeliveryModesService, CheckoutPageMetaResolver, CheckoutPaymentAdapter, CheckoutPaymentConnector, CheckoutPaymentService, CheckoutQueryService, DELIVERY_MODE_NORMALIZER, PAYMENT_CARD_TYPE_NORMALIZER, PAYMENT_DETAILS_SERIALIZER };
